import tw, { styled } from "twin.macro";
import Paragraph from "@/components/Atoms/Paragraph";
import { styledWrapperBase } from "@/styles/common";

export const StyledFooterRoot = styled.div`
  ${tw`bg-neutral-10`}
`;

export const StyledText = styled(Paragraph)`
  ${tw`text-neutral-100`}
`;

export const StyledWrapperFooter = styled.footer`
  ${tw`h-full w-full px-m pt-ml pb-[4rem]  flex flex-col gap-ml
  medium:(px-l grid grid-cols-[repeat(2, minmax(202px, 538px))] justify-center gap-y-l) large:(grid-cols-3 pb-20 px-m!)
  `}
  ${styledWrapperBase}
`;

export const StyledSectionBusinessHours = styled.section`
  ${tw`flex flex-col gap-m`}
`;
export const StyledWrapperCity = styled.div`
  ${tw`grid gap-4 medium:(gap-ml)`}
  & > div {
    ${tw`flex flex-col gap-2
    `}

    & > a p {
      ${tw`underline text-white`}
    }

    & > div,
    a {
      ${tw`flex gap-2 items-center`}
      & > svg {
        ${tw`w-4 h-4`}
        & > path {
          ${tw`fill-neutral-80`}
        }
      }
    }
  }
`;

export const StyledContactContainer = styled.section`
  ${tw`medium:(col-start-2 col-end-3 row-start-1 row-end-2)`}
`;

export const StyledContactWrapper = styled.div`
  ${tw`flex flex-col gap-ml`}
`;

export const StyledRowContact = styled.div`
  ${tw`flex gap-s items-center`}

  svg {
    ${tw`w-4 h-4`}
    & > path {
      ${tw`fill-neutral-100`}
    }
  }
`;

export const StyledColumnContact = styled.div`
  ${tw`flex flex-col gap-s`}
`;

export const StyledSectionNewLetter = styled.section`
  ${tw`flex flex-col gap-[1.75rem] large:(col-span-2)`}
`;
export const StyledInfoNewLetter = styled.div``;

export const StyledSectionQuickLinks = styled.section`
  ${tw`w-full flex gap-s justify-between large:(grid grid-cols-[1fr_max-content])`}
`;

export const StyledLinksSection = styled.div`
  ${tw`flex flex-col gap-s`}

  .link-item {
    ${tw`text-neutral-100 underline w-max p-0 hover:(bg-transparent)`}

    p {
      ${tw`text-[0.75rem] leading-[1.035rem] medium:(text-[0.813rem] leading-[1.121rem] large:(text-[0.875rem] leading-[1.208rem]))`}
    }

    svg {
      ${tw`w-4 h-4`}
    }
  }
`;

export const StyledHr = styled.div`
  ${tw` bg-neutral-40 h-[0.063rem] w-full`}
`;

export const StyledWrapperSocialNetwork = styled.div`
  ${tw`flex items-center  justify-between medium:(gap-ml) large:(gap-l justify-end)`}

  svg {
    ${tw`w-6 h-6`}
  }
`;

export const StyledLegalSection = styled.section`
  ${tw`flex flex-col gap-ml medium:(flex-row col-start-1 col-end-3 justify-between flex-wrap gap-l) large:(col-span-3) large:(gap-m grid grid-cols-[max-content_max-content_1fr] items-end)`}
`;

export const StyledLegalLinksContainer = styled.div`
  ${tw`flex items-center justify-between  medium:(-order-1) medium:(gap-m) large:(row-start-1 col-start-2)`}

  .link-legals {
    ${tw`underline text-center`}
  }
`;

export const StyledBrandContainer = styled.div`
  ${tw`flex justify-between items-end medium:(w-full justify-center gap-s) large:( gap-m w-max row-start-1 col-start-1) `}
`;

export const StyledTextContact = styled(Paragraph)`
  ${tw`text-[0.813rem] medium:(text-[0.813rem] large:(text-[0.875rem]))`}
`;

export const StyledAddressItem = styled.div`
  ${tw`flex items-center gap-s`}
`;
